import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  changeCurrentMemberMenu,
  // screenChange,
  changeisNavigationFromEventToMember,
} from "../../store/screenSlice";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "../../Styles/TableStyles.scss";
import "../../Styles/CommonStyles.scss";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { TextField } from "@mui/material";
import { screenConfig } from "../../config/screenConfig";
import { DevTool } from "@hookform/devtools";
import CurrencyInput from "react-currency-input-field";
import deleteIcon from "./../../Images/Delete.png";
import {
  useForm,
  Controller,
  useFormContext,
  Merge,
  FieldError,
  FieldErrorsImpl,
} from "react-hook-form";
import currentMemberSlice, {
  assignCurrentMember,
} from "../../store/currentMemberSlice";
import {
  Button,
  PageLink,
  SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import { DateValidationError } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { all } from "axios";
import { invalid } from "moment";
import ReactModal from "react-modal";
import MemberServices from "../../services/MemberServices";
import EventServices from "../../services/EventServices";
import AddCostInfo from "./AddCostInfo";
import AddLocationInfo from "./AddLocationInfo";
import { assignEvent, updateEvent } from "../../store/eventApiSlice";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import CreateVideoEvent from "./CreateVideoEvent";
import * as routeConfig from "../../config/routes";
import { setCurrentOrderId } from "../../store/orderApiSlice";
import ReactPlayer from "react-player";
import { useAppSelector } from "../../store/hooks";
import ParticipantList from "./ParticipantList";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import DeleteIcon from "@mui/icons-material/Delete";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import Modal from "react-bootstrap/Modal";
type FormValues = {
  EventName: string;
  Description: string;
  UniqueEventId: string;
  EventType: string;
  EventCategory: string;
  StartDateTime: string;
  EndDateTime: string;
  EarlyBirdBy: string;
  Available: number;
  AvailableOnline: string;
  SponsorName: string;
  RegistrationLink: string;
  ZoomMeetingID: string;
  ZoomRegLink: string;
  DECredits: number;
  DEEnchEthics: number;
  PACredits: number;
  PAEthics: number;
  NJCredits: number;
  NJEthics: number;
  Comments: string;
  MaterialLink: string;
  Location: string;
  LocationCost: number;
  CostName: string;
  CostNameCost: number;
};

type FormValues1 = {
  CostName: string;
  CostNameCost: number;
};

interface IConfiguration {
  [key: string]: any;
}

interface Cost {
  CostId: number | null;
  CostName: string | null;
  Cost: number | null;
}
interface Istate {
  data: {
    OrderId: number;
    EventId: number;
    EventType: string;
  };
}

const ViewEvent: React.FC = () => {
  console.log("ViewEvent");
  const dispatch = useDispatch();
  // dispatch(screenChange("Events"));

  const form = useForm<FormValues>();
  const formCost = useForm<FormValues1>({ mode: "onSubmit" });
  const { register, control, handleSubmit, formState, setValue } = form;
  const { errors } = formState;
  const [addCodeOpen, setAddCodeOpen] = useState(false);
  const [memberDetail, setmemberDetail] = useState<any>();
  const [state, setState] = useState<Istate>({
    data: {
      OrderId: 0,
      EventId: 0,
      EventType: "",
    },
  });
  const {
    register: registerCost,
    control: controlCost,
    handleSubmit: handleSubmitCost,
    formState: { errors: errorsCost },
    setValue: setValueCost,
  } = formCost;
  const [attendanceState, setAttendanceState] = useState<
    Record<string, boolean>
  >({});
  // const { errors: errorsCost } = formStateCost;

  // const eventInfo = useSelector((state: RootState) => state.eventapislice);
  // console.log("event:", eventInfo);

  const [printNameCardModalOpen, setprintNameCardModalOpen] = useState(false);
  const [printTableCardModalOpen, setprintTableCardModalOpen] = useState(false);

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const eventInfo = useSelector(
    (state: RootState) => state.eventapislice.event
  );

  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  console.log("event:", eventInfo);
  const navigate = useNavigate();

  const onSubmit = async () => {
    // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
    navigate(routeConfig.EVENT_URL, { replace: false });
  };

  const editEvent = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("events.edit")
      )
    ) {
      alert("No Access");
      return;
    }
    dispatch(assignEvent(eventInfo));
    // dispatch(changeCurrentMemberMenu(screenConfig.editEvent));
    navigate(routeConfig.EDIT_EVENT_URL, { replace: false });
  };
  const color1 = "#2d6289";
  const textColor = "#25284e";

  const getCurrentEvent = React.useCallback(
    async (EventId: number) => {
      console.log("getCurrentEvent:", EventId);
      const response = await EventServices.getViewEventId(EventId);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("getCurrentEvent-Success:", response.data.data);
        dispatch(assignEvent(response.data.data));
        console.log("Dispatched action:", response.data.data);
      } else {
        console.log("Error: Data not received");
      }
    },
    [dispatch]
  );

  useEffect(() => {
    console.log("getCurrentEvent:useeffect");
    console.log("roleCapabilites:", roleCapabilites);
    if (eventInfo.Id) {
      getCurrentEvent(eventInfo.Id);
    } else {
      console.log("empty event id"); // will happen on browser refresh
      navigate(routeConfig.EVENT_URL, { replace: false });
    }
  }, [eventInfo.Id, roleCapabilites, navigate, getCurrentEvent]);

  // const muiTextFieldTheme
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        // error: {
        //   main: color1,
        // },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              // borderBottomStyle: "solid",
              // borderBottomWidth: 1,
              boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.05) inset",
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
              paddingTop: "20px",
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "0px",
              fontWeight: "400",
              "&.Mui-disabled": {
                WebkitTextFillColor: textColor,
              },
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
              "&.Mui-disabled": {
                color: color1,
              },
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiTextField: {
          styleOverrides: {
            root: {
              // marginBottom: "1.8rem",
            },
          },
        },
      },
    });

  const muiTextInputColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
      },

      components: {
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.05) inset",
            },
            input: {
              "&.Mui-disabled": {
                WebkitTextFillColor: textColor,
              },
            },
          },
        },
      },
    });

  const createVideoEvent = () => {
    console.log("create view Event");
    // dispatch(screenChange("CreateVideoEvent"));
    // dispatch(changeCurrentMemberMenu(screenConfig.createVideoEvent));
    // navigate("/events", { replace: true });
    navigate(routeConfig.CREATE_VIDEO_EVENT_URL, { replace: false });
  };

  const openVideoEvent = () => {
    // dispatch(
    //   updateEvent({
    //     key: "Id",
    //     value: eventInfo.ChildEventId as number,
    //   })
    // );
    getCurrentEvent(eventInfo.ChildEventId as number);
  };

  const updateInputs = (input: string | null) => {
    return (input ?? "").replace(/[^\w\s./:]/gi, "");
  };

  const copyToClipboard = (type: string) => {
    if (type === "VideoURL" && eventInfo && eventInfo.VideoURL) {
      navigator.clipboard.writeText(eventInfo.VideoURL).then(
        () => {
          toast("Link copied to clipboard!");
        },
        (err) => {
          toast("Failed to copy: ", err);
        }
      );
    }
    if (type === "MaterialLink" && eventInfo && eventInfo.MaterialLink) {
      navigator.clipboard.writeText(eventInfo.MaterialLink).then(
        () => {
          toast("Link copied to clipboard!");
        },
        (err) => {
          toast("Failed to copy: ", err);
        }
      );
    }
  };

  const handleDeleteClick = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("events.edit")
      )
    ) {
      alert("No Access to delete events");
      return;
    }
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (!eventInfo) return;

    setIsDeleting(true);
    try {
      const response = await EventServices.deleteEvent(eventInfo.Id);
      console.log("Delete response:", response);

      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Delete Error");
        setAlertBody(
          response.data.errors[0].message || "Failed to delete event"
        );
      } else {
        // Success - show success message and navigate back
        setShowAlertModal(true);
        setAlertTitle("Success");
        setAlertBody(
          `Event "${eventInfo.EventName}" (${eventInfo.UniqueEventId}) has been deleted successfully.`
        );

        // Navigate back to events list after delay
        setTimeout(() => {
          navigate("/events");
        }, 2000);
      }
    } catch (error: any) {
      console.error("Delete error:", error);
      setShowAlertModal(true);
      setAlertTitle("Delete Error");
      setAlertBody(error.response?.data?.message || "Failed to delete event");
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
  };

  const PrintLabelRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({ content: () => PrintLabelRef.current });

  return (
    <>
      <ToastContainer />
      <div
        className="dashboard-content-wrapper"
        style={{ marginBottom: "20px" }}
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Event Details</h1>
          <div
            className="d-flex"
            style={{
              marginTop: "0.5rem",
            }}
          >
            {eventInfo.EventType !== "Video" &&
            eventInfo.ChildEventId === null ? (
              <SecondaryWhiteButton
                className="button-wrapper"
                type="button"
                style={{
                  marginRight: "1.8rem",
                  marginLeft: "1.8rem",
                }}
                onClick={createVideoEvent}
              >
                <span style={{ fontWeight: "500" }}> Create Video Event</span>
              </SecondaryWhiteButton>
            ) : eventInfo.EventType !== "Video" &&
              eventInfo.ChildEventId !== null ? (
              <SecondaryWhiteButton
                className="button-wrapper"
                type="button"
                style={{
                  marginRight: "1.8rem",
                  marginLeft: "1.8rem",
                }}
                onClick={openVideoEvent}
              >
                <span style={{ fontWeight: "500" }}>
                  Video Event ID: {eventInfo.ChildEventId}
                </span>
              </SecondaryWhiteButton>
            ) : (
              <></>
            )}
            {eventInfo.EventType !== "Video" ? (
              <>
                <SecondaryWhiteButton
                  className="button-wrapper"
                  type="button"
                  style={{
                    marginRight: "1.8rem",
                    marginLeft: "1.8rem",
                  }}
                  onClick={() => {
                    if (
                      eventInfo.OrderDetail == null ||
                      (eventInfo.OrderDetail != null &&
                        eventInfo.OrderDetail.length === 0)
                    ) {
                      alert("No participants enrolled to this event");
                      return;
                    } else {
                      setprintTableCardModalOpen(true);
                    }
                  }}
                >
                  <span style={{ fontWeight: "500" }}>Print Table Card</span>
                </SecondaryWhiteButton>
                <SecondaryWhiteButton
                  className="button-wrapper"
                  type="button"
                  style={{
                    marginRight: "1.8rem",
                    marginLeft: "1.8rem",
                  }}
                  onClick={() => {
                    if (
                      eventInfo.OrderDetail == null ||
                      (eventInfo.OrderDetail != null &&
                        eventInfo.OrderDetail.length === 0)
                    ) {
                      alert("No participants enrolled to this event");
                      return;
                    } else {
                      setprintNameCardModalOpen(true);
                    }
                  }}
                >
                  <span style={{ fontWeight: "500" }}>Print Name Card</span>
                </SecondaryWhiteButton>
              </>
            ) : (
              <></>
            )}
            <div
              style={{ cursor: "pointer", paddingRight: "1rem", color: "blue" }}
              onClick={editEvent}
            >
              <PageLink>Edit </PageLink>
            </div>
            {roleCapabilites.some((obj: any) =>
              Object.values(obj).includes("events.edit")
            ) && (
              <div
                style={{
                  cursor: "pointer",
                  paddingRight: "0rem",
                  color: "red",
                }}
                onClick={handleDeleteClick}
              >
                <PageLink>Delete </PageLink>
              </div>
            )}
          </div>
        </div>
        {/* ----------Event Information------------ */}
        <div className="section-box">
          <h3 className="section-heading">Event Information</h3>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-large">
              <input
                className="input-field-div-small"
                placeholder=""
                id="EventName"
                {...register("EventName", {
                  required: "* required field",
                })}
                // autoComplete="off"
                // onChange={(e) => {
                //   updateInput(e);
                // }}
                disabled={true}
                value={eventInfo.EventName as string}
              />
              <label className="form-label" htmlFor="EventName">
                Event Name
              </label>
            </div>
            <div className="input-field-div-wrapper-large">
              <input
                className="input-field-div-small"
                placeholder=""
                id="UniqueEventId"
                {...register("UniqueEventId", {
                  required: "* required field",
                })}
                disabled={true}
                value={eventInfo.UniqueEventId as string}
              />
              <label className="form-label" htmlFor="UniqueEventId">
                Event ID
              </label>
            </div>
          </div>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-medium">
              <input
                className="input-field-div-small"
                placeholder=""
                id="EventType"
                {...register("EventType", {
                  required: "* required field",
                })}
                disabled={true}
                value={eventInfo.EventType as string}
              />
              <label className="form-label" htmlFor="EventType">
                Event Type
              </label>
            </div>

            <div className="input-field-div-wrapper-medium">
              <Controller
                control={control}
                name="StartDateTime"
                rules={{ required: "* required field" }}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        className="datepicker-local"
                        label="Start Date"
                        // value={StartDateTime}
                        disabled={true}
                        value={dayjs(eventInfo.StartDateTime)}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>

            <div className="input-field-div-wrapper-medium">
              <Controller
                control={control}
                name="EndDateTime"
                rules={{ required: "* required field" }}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        className="datepicker-local"
                        label="End Date"
                        disabled={true}
                        value={dayjs(eventInfo.EndDateTime)}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>

            <div className="input-field-div-wrapper-medium">
              <Controller
                control={control}
                name="EarlyBirdBy"
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        className="datepicker-local"
                        label="Early Bird By"
                        disabled={true}
                        value={dayjs(eventInfo.EarlyBirdBy)}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>
          </div>
          <div className="textarea-wrapper" style={{ width: "100%" }}>
            <ThemeProvider theme={muiTextInputColorTheme}>
              <TextField
                className="textarea"
                id="Description"
                placeholder="Event Description"
                multiline
                rows={3}
                disabled={true}
                value={eventInfo.Description as string}
              />
            </ThemeProvider>
          </div>
          <div className="horizontal-wrapper-spacebetween">
            {/* video URL */}
            {eventInfo.EventType === "Video" ? (
              <>
                <div
                  className="form-wrapper-vertical"
                  style={{
                    // height: "5.8rem",
                    width: "45%",
                  }}
                >
                  <div
                    className="input-field-div-wrapper-large"
                    style={{ width: "100%" }}
                  >
                    <input
                      className="input-field-div-small"
                      placeholder=""
                      id="VideoURL"
                      name="VideoURL"
                      readOnly={true}
                      value={eventInfo.VideoURL as string}
                    />
                    <label className="form-label" htmlFor="VideoURL">
                      Video Link
                    </label>
                  </div>
                  {/* <div className="horizontal-wrapper-rightaligned">
                    <div
                      style={{
                        width: "auto",
                        height: "2rem",
                      }}
                    >
                      <a href={eventInfo.VideoURL as string} target="_blank">
                        <PlayCircleOutlineIcon />
                        Play
                      </a>
                    </div>
                    <div
                      style={{
                        width: "auto",
                        height: "2rem",
                        display: "flex",
                        alignItems: "left",
                        cursor: "pointer",
                        color: "#1976d2",
                        paddingLeft: ".8rem",
                      }}
                      onClick={(string) => copyToClipboard("VideoURL")}
                    >
                      <a>
                        <CopyAllIcon />
                        Copy
                      </a>
                    </div>
                  </div> */}
                </div>
              </>
            ) : (
              <></>
            )}
            {/* Material link */}
            <div
              className="form-wrapper-vertical"
              style={{
                // height: "5.8rem",
                width: "45%",
              }}
            >
              <div
                className="input-field-div-wrapper-large"
                style={{ width: "100%" }}
              >
                <input
                  className="input-field-div-small"
                  placeholder=""
                  id="MaterialLink"
                  name="MaterialLink"
                  autoComplete="off"
                  disabled={true}
                  value={eventInfo.MaterialLink as string}
                />
                <label className="form-label" htmlFor="MaterialLink">
                  Material Link
                </label>
              </div>
              {/* {eventInfo.MaterialLink !== null ? (
                <div className="horizontal-wrapper-rightaligned">
                  <div
                    style={{
                      width: "auto",
                      height: "2rem",
                    }}
                  >
                    <a href={eventInfo.MaterialLink as string} target="_blank">
                      <OpenInNewIcon />
                      View
                    </a>
                  </div>
                  <div
                    style={{
                      width: "auto",
                      height: "2rem",
                      display: "flex",
                      alignItems: "left",
                      cursor: "pointer",
                      color: "#1976d2",
                      paddingLeft: ".8rem",
                    }}
                    onClick={(string) => copyToClipboard("MaterialLink")}
                  >
                    <a>
                      <CopyAllIcon />
                      Copy
                    </a>
                  </div>
                </div>
              ) : (
                <></>
              )} */}
              {/* <a
                className="view-button p-1"
                href={eventInfo.MaterialLink as string}
                target="_blank"
              >
                <OpenInNewIcon />
              </a> */}
            </div>

            {eventInfo.EventType !== "Video" ? (
              <div className="input-field-div-wrapper-large">
                <input
                  className="input-field-div-small"
                  placeholder=""
                  id="RegistrationLink"
                  {...register("RegistrationLink", {
                    required: "* required field",
                  })}
                  disabled={true}
                  // value={updateInputs(eventInfo.RegistrationLink as string)}
                  value={
                    eventInfo.RegistrationLink ? eventInfo.RegistrationLink : ""
                  }
                />
                <label className="form-label" htmlFor="RegistrationLink">
                  Registration Link
                </label>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="horizontal-wrapper-spacebetween">
            {/* Registration link if it is a video event */}
            {eventInfo.EventType === "Video" ? (
              <div className="input-field-div-wrapper-large">
                <input
                  className="input-field-div-small"
                  placeholder=""
                  id="RegistrationLink"
                  {...register("RegistrationLink", {
                    required: "* required field",
                  })}
                  disabled={true}
                  // value={updateInputs(eventInfo.RegistrationLink as string)}
                  value={
                    eventInfo.RegistrationLink ? eventInfo.RegistrationLink : ""
                  }
                />
                <label className="form-label" htmlFor="RegistrationLink">
                  Registration Link
                </label>
              </div>
            ) : (
              <></>
            )}
            <div
              className={
                eventInfo.EventType !== "Video"
                  ? "input-field-div-wrapper-smaller"
                  : "input-field-div-wrapper-large"
              }
            >
              <input
                className="input-field-div-small"
                placeholder=""
                id="SponsorName"
                name="SponsorName"
                disabled={true}
                value={eventInfo.SponsorName as string}
              />
              <label className="form-label" htmlFor="SponsorName">
                Sponsor
              </label>
            </div>

            {/* Zoom Id detail */}
            {eventInfo.EventType !== "Video" ? (
              <>
                <div className="input-field-div-wrapper-small">
                  <input
                    className="input-field-div-small"
                    placeholder=""
                    id="ZoomMeetingID"
                    name="ZoomMeetingID"
                    disabled={true}
                    value={eventInfo.ZoomMeetingID as string}
                  />
                  <label className="form-label" htmlFor="ZoomMeetingID">
                    Zoom Meeting ID
                  </label>
                </div>

                <div className="input-field-div-wrapper-large">
                  <input
                    className="input-field-div-small"
                    placeholder=""
                    id="ZoomRegLink"
                    name="ZoomRegLink"
                    disabled={true}
                    value={eventInfo.ZoomRegLink as string}
                  />
                  <label className="form-label" htmlFor="ZoomRegLink">
                    Zoom Meeting Link
                  </label>
                </div>

                <div className="input-field-div-wrapper-large">
                  <input
                    className="input-field-div-small"
                    placeholder=""
                    id="AvailableOnline"
                    name="AvailableOnline"
                    disabled={true}
                    value={eventInfo.AvailableOnline === 1 ? "Yes" : "No"}
                  />
                  <label className="form-label" htmlFor="AvailableOnline">
                    Available for registration
                  </label>
                </div>
              </>
            ) : (
              <>
                <div className="input-field-div-wrapper-large">
                  <input
                    className="input-field-div-small"
                    placeholder=""
                    id="AvailableOnline"
                    name="AvailableOnline"
                    disabled={true}
                    value={eventInfo.AvailableOnline === 1 ? "Yes" : "No"}
                  />
                  <label className="form-label" htmlFor="AvailableOnline">
                    Available for registration
                  </label>
                </div>
              </>
            )}
          </div>
        </div>

        {/* ----------Credit Information------------ */}
        <div className="section-box">
          <h3 className="section-heading">Credit Information</h3>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="DECredits"
                name="DECredits"
                disabled={true}
                value={eventInfo.DECredits as number}
                // autoComplete="off"
                // onChange={(e) => {
                //   updateInput(e);
                // }}
              />
              <label className="form-label" htmlFor="DECredits">
                DE Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="DEEnchEthics"
                name="DEEnchEthics"
                disabled={true}
                value={eventInfo.DEEnchEthics as number}
                // autoComplete="off"
                // onChange={(e) => {
                //   updateInput(e);
                // }}
              />
              <label className="form-label" htmlFor="DEEnchEthics">
                DE Ethics
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="PACredits"
                name="PACredits"
                disabled={true}
                value={eventInfo.PACredits as number}
                // autoComplete="off"
                // onChange={(e) => {
                //   updateInput(e);
                // }}
              />
              <label className="form-label" htmlFor="PACredits">
                PA Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="PAEthics"
                name="PAEthics"
                disabled={true}
                value={eventInfo.PAEthics as number}
                // autoComplete="off"
                // onChange={(e) => {
                //   updateInput(e);
                // }}
              />
              <label className="form-label" htmlFor="PAEthics">
                PA Ethics
              </label>
            </div>
          </div>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="NJCredits"
                name="NJCredits"
                disabled={true}
                value={eventInfo.NJCredits as number}
                // autoComplete="off"
                // onChange={(e) => {
                //   updateInput(e);
                // }}
              />
              <label className="form-label" htmlFor="NJCredits">
                NJ Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="NJEthics"
                name="NJEthics"
                disabled={true}
                value={eventInfo.NJEthics as number}
                // autoComplete="off"
                // onChange={(e) => {
                //   updateInput(e);
                // }}
              />
              <label className="form-label" htmlFor="NJEthics">
                NJ Ethics
              </label>
            </div>
          </div>
        </div>
        {/* ----------Cost Information------------ */}

        {eventInfo.EventType === "Video" ? (
          <div className="section-box">
            <h3 className="section-heading">Cost Information</h3>
            <div className="horizontal-wrapper-spacebetween">
              <div className="input-field-div-wrapper-smallnominwidth">
                <input
                  className="input-field-div-small"
                  id="MemberCostPerHour"
                  placeholder=""
                  disabled={true}
                  value={eventInfo.MemberCostPerHour ?? 0}
                />
                <label className="form-label" htmlFor="MemberCostPerHour">
                  Member Cost / Hour
                </label>
              </div>

              <div className="input-field-div-wrapper-smallnominwidth">
                <input
                  className="input-field-div-small"
                  id="NonMemberCostPerHour"
                  placeholder=""
                  disabled={true}
                  value={eventInfo.NonMemberCostPerHour ?? 0}
                />
                <label className="form-label" htmlFor="NonMemberCostPerHour">
                  Non Member Cost / Hour
                </label>
              </div>

              <div className="input-field-div-wrapper-smallnominwidth">
                <input
                  className="input-field-div-small"
                  id="MemberCost"
                  placeholder=""
                  disabled={true}
                  value={eventInfo.MemberCost ?? 0}
                />
                <label className="form-label" htmlFor="MemberCost">
                  Member Cost Online
                </label>
              </div>

              <div className="input-field-div-wrapper-smallnominwidth">
                <input
                  className="input-field-div-small"
                  id="NonMemberCost"
                  placeholder=""
                  disabled={true}
                  value={eventInfo.NonMemberCost ?? 0}
                />
                <label className="form-label" htmlFor="NonMemberCost">
                  Non Member Cost Online
                </label>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="horizontal-wrapper-spacebetween">
              <div className="section-box" style={{ width: "48%" }}>
                <h3 className="section-heading">Cost Information</h3>
                <div className="horizontal-wrapper-spacebetween">
                  {eventInfo.Costs!.map((eventcostitem) => (
                    <div
                      className="form-wrapper-space-around "
                      key={eventcostitem.Id}
                    >
                      <div className="cost-name-extralarge">
                        {eventcostitem.CostName as string}
                      </div>
                      <div className="cost-name-smaller">
                        {Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(eventcostitem.Cost as number)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="section-box" style={{ width: "48%" }}>
                <h3 className="section-heading">Location Information</h3>

                <div className="horizontal-wrapper-spacebetween">
                  {eventInfo.Locations!.map((eventlocationitem) => (
                    <div className="form-wrapper" key={eventlocationitem.Id}>
                      <div className="cost-name-extralarge">
                        {eventlocationitem.Location as string}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}

        <ParticipantList isEditMode={false} />
        {/* </> */}
        {/* </div> */}

        <ReactModal
          isOpen={printTableCardModalOpen}
          onRequestClose={() => setprintTableCardModalOpen(false)}
          className="printA4Sheet-modal"
          overlayClassName="overlay"
        >
          <div className="horizontal-wrapper-spacebetween">
            <h5
              style={{
                width: "auto",
                marginLeft: "30px",
                marginRight: "0px",
                marginTop: "15px",
                fontSize: "1.4rem",
                marginBottom: "15px",
                color: "var(--secondary-color)",
              }}
            >
              Table Card
            </h5>
            <div
              className="horizontal-wrapper-rightaligned"
              style={{
                width: "auto",
                marginLeft: "0px",
                marginRight: "30px",
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              <SecondaryWhiteButton
                className="button-wrapper"
                type="button"
                style={{
                  marginRight: ".5rem",
                  marginLeft: ".5rem",
                }}
                onClick={() => handlePrint()}
              >
                <span style={{ fontWeight: "500" }}>Print</span>
              </SecondaryWhiteButton>
              <PageLink
                onClick={() => {
                  setprintTableCardModalOpen(false);
                }}
              >
                Close
              </PageLink>
            </div>
          </div>
            <div className="printA4Sheet-div" ref={PrintLabelRef}>
              {eventInfo.OrderDetail != null && eventInfo.OrderDetail.length > 0 ? (
                eventInfo.OrderDetail
                  .filter((orderItem) =>
                    orderItem.ParticipantType === "Moderator" ||
                    orderItem.ParticipantType === "Speaker"
                  )
                  .map((orderItem) => (
                    <div className="printA4Sheet-page" key={orderItem.Id}>
                      <div className="tableCardParent">
                        <div className="tableCard">
                          <div>
                            <div className="tableCardTitle">
                              {orderItem.Esquire &&
                              orderItem.Esquire.includes("Hon")
                                ? "The Honorable"
                                : null}
                            </div>
                            <div className="tableCardTitle">
                              {orderItem.FirstName} {orderItem.LastName}
                              {orderItem.Esquire &&
                              orderItem.Esquire.includes("Hon")
                                ? null
                                : ","}
                              {orderItem.Esquire &&
                              orderItem.Esquire.includes("Hon")
                                ? null
                                : " Esq."}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
              ) : (
                <></>
              )}
            </div>
        </ReactModal>

        <ReactModal
          isOpen={printNameCardModalOpen}
          onRequestClose={() => setprintNameCardModalOpen(false)}
          className="printA4Sheet-modal"
          overlayClassName="overlay"
        >
          <div className="horizontal-wrapper-spacebetween">
            <h5
              style={{
                width: "auto",
                marginLeft: "30px",
                marginRight: "0px",
                marginTop: "15px",
                fontSize: "1.4rem",
                marginBottom: "15px",
                color: "var(--secondary-color)",
              }}
            >
              Name Card
            </h5>
            <div
              className="horizontal-wrapper-rightaligned"
              style={{
                width: "auto",
                marginLeft: "0px",
                marginRight: "30px",
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              <SecondaryWhiteButton
                className="button-wrapper"
                type="button"
                style={{
                  marginRight: ".5rem",
                  marginLeft: ".5rem",
                }}
                onClick={() => handlePrint()}
              >
                <span style={{ fontWeight: "500" }}>Print</span>
              </SecondaryWhiteButton>
              <PageLink
                onClick={() => {
                  setprintNameCardModalOpen(false);
                }}
              >
                Close
              </PageLink>
            </div>
          </div>
          <div className="printA4Sheet-div" ref={PrintLabelRef}>
            <div
              className="printA4Sheet-page"
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "start",
                flexDirection: "row",
                justifyContent: "space-evenly",
              }}
            >
              {eventInfo.OrderDetail != null &&
              eventInfo.OrderDetail.length > 0 ? (
                eventInfo.OrderDetail.map((orderItem) =>
                  orderItem.ParticipantType === "Moderator" ||
                  orderItem.ParticipantType === "Speaker" ? (
                    <div className="nameCardSize" key={orderItem.Id}>
                      <div
                        className="nameCardGroup"
                        style={{
                          // textAlign: "center",
                          borderTop: "3px solid black",
                          borderBottom: "3px solid black",
                          paddingTop: "10px",
                          paddingBottom: "10px",
                          height: "20%",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "800",
                          }}
                        >
                          Delaware State Bar Association
                        </span>
                      </div>
                      <div className="nameCardGroup" style={{ height: "80%" }}>
                        <div className="nameCard">
                          {orderItem.Esquire &&
                          orderItem.Esquire.includes("Hon")
                            ? "The Honorable"
                            : null}
                        </div>
                        <div className="nameCard">
                          {orderItem.FirstName} {orderItem.LastName}
                          {orderItem.Esquire &&
                          orderItem.Esquire.includes("Hon")
                            ? null
                            : ", Esq."}
                        </div>
                        {/* <div
                        className="nameCard"
                        // style={{ marginBottom: "40px" }}
                      >
                        {orderItem.Esquire === "Esq" ? ",Esq." : null}
                      </div> */}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )
                )
              ) : (
                <></>
              )}
            </div>
          </div>
        </ReactModal>

        {/* ----------Submit button Information------------ */}
        <div className="submit-floating-button-div">
          <Button
            className="submit-button-div"
            type="submit"
            onClick={() => {
              onSubmit();
            }}
          >
            Close
          </Button>
        </div>
        {/* </form> */}
        {/* cost modal */}
        {/* <ReactModal
        isOpen={CostModalOpen}
        // onRequestClose={() => setCostModalOpen(false)}
        className="editinfo-modal-large"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            Add Cost Information
          </h1>
          <PageLink
            onClick={() => setCostModalOpen(false)}
            style={{ marginBottom: "2rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <AddCostInfo closeCostModal={closeCostModal} />
      </ReactModal> */}
        {/* Location modal */}
        {/* <ReactModal
        isOpen={LocationModalOpen}
        // onRequestClose={() => setLocationModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            Add Location Information
          </h1>
          <PageLink
            onClick={() => setLocationModalOpen(false)}
            style={{ marginBottom: "2rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <AddLocationInfo closeLocationModal={closeLocationModal} />
      </ReactModal> */}
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={handleDeleteCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Event</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this event?</p>
          {eventInfo && (
            <div>
              <strong>Event Name:</strong> {eventInfo.EventName}
              <br />
              <strong>Event ID:</strong> {eventInfo.UniqueEventId}
              <br />
              <strong>Start Date:</strong>{" "}
              {eventInfo.StartDateTime
                ? dayjs(eventInfo.StartDateTime).format("MM-DD-YYYY hh:mm A")
                : "--"}
              <br />
            </div>
          )}
          <p className="text-danger mt-3">
            <strong>Warning:</strong> This action cannot be undone. All related
            data including orders, registrations, and credits will be
            permanently deleted.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={handleDeleteCancel}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger"
            onClick={handleDeleteConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete Event"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ViewEvent;
